import { ConfigProvider } from '@inboundx/shared/config';
import { PreviewHostProvider } from '@inboundx/shared/widget';
import type { ComponentProps } from 'react';
import type { Client } from '../contexts/AppContext';

type ClientConfigProviderProps = Omit<ComponentProps<typeof ConfigProvider>, 'effectiveDomain'> & {
    client: Pick<Client, 'id' | 'domain' | 'pageUrl'>;
};

/**
 * Widget config for the selected workspace. A path-rooted workspace's widget stands in for
 * its root page (IX-5069); ConfigProvider reads that once per mount, hence the key.
 */
export function ClientConfigProvider({ client, children, ...props }: ClientConfigProviderProps) {
    return (
        <PreviewHostProvider host={{ pageUrl: client.pageUrl }}>
            <ConfigProvider key={client.id} effectiveDomain={client.domain} {...props}>
                {children}
            </ConfigProvider>
        </PreviewHostProvider>
    );
}
